import { TripBookingDispatchPlaceMappingType } from '../../lib/types/models/trip-booking-dispatch-places/trip-booking-dispatch-place'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripBookingDispatchPlace<T extends keyof TripBookingDispatchPlaceMappingType>(
  id: number,
  version: keyof TripBookingDispatchPlaceMappingType
) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.tripBookingDispatchPlaces.get.url, { id }), {
        version
      })
    )
    .get<TripBookingDispatchPlaceMappingType[T]>()
}
